module.exports = __webpack_public_path__ + "img/oneBlue.6ba600f1.jpg";